var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QS-login',{attrs:{"loading":_vm.loading,"count-number":_vm.countNumber,"passwordLength":6,"system-name":_vm.SystemName},on:{"handleSendMsg":_vm.handleSendMsg,"handleLogin":_vm.handleLogin}})
}
var staticRenderFns = []

export { render, staticRenderFns }